
import { Component, Vue, Prop } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import SidebarItem from './SidebarItem.vue'
import logo1 from '../../../../assets/images/ryylogo.png'
import logolt from '../../../../assets/images/logoltong.png'
import logoltmin from '../../../../assets/images/logoltingsamll.png'



import logo4 from '../../../../assets/images/logo.png'

import logo2 from '../../../../assets/images/lgo.png'
import logo3 from '../../../../assets/images/光谷环保logo-02.png'
import logozsybig from '../../../../assets/images/logozsybig.png'
import logozsysmall from '../../../../assets/images/logozsysmall.png'
import logoadminbig from '../../../../assets/images/logoadminbig.png'
import logoadminsmall from '../../../../assets/images/logoadminsmall.png'
import zjwj from '../../../../assets/images/zjwj.png'
import ztjt from '../../../../assets/images/ztjt.png'


import logoDH from '../../../../assets/images/logoDH.jpg'
import { log } from 'console'
import {UserModule} from '@/store/modules/user'

@Component({
  components: {
    SidebarItem,
  },
})
export default class SideBar extends Vue {
  @Prop({ default: false }) private collapse!: boolean


  
  private orgId=localStorage.getItem('orgId')
  
  
  private logo1=logo1
  private logo2=logo2
  private logo3=logo3
  private logo4=logo4
  private logozsybig=logozsybig
  private logozsysmall=logozsysmall
  private logoadminbig=logoadminbig
  private logoadminsmall=logoadminsmall
  private logoDH=logoDH
  
  private state=process.env.VUE_APP_BELONG_GROUP 
  private ltmax=logolt
  private ltmin=logoltmin
  private zjwj=zjwj
  private ztjt=ztjt

  private orglist=[
    {orgId:'d6c57398-3a47-4cd6-861f-d7098e238e1f',orgName:'北京名人大厦',logobig:this.logozsybig
      ,logosmall:this.logozsysmall
    },
    {orgId:'8b42f0f4-4b13-40ca-817c-fc4050bfea87',orgName:'东湖高新',logobig:this.logo2,
    logosmall:this.logo3},
    {
      orgId:'de0789c2-4372-426e-b771-59885dc902f2',orgName:'中石油',logobig:this.logozsybig,
      logosmall:this.logozsysmall
    },
    {
      orgId:'cb55e6ea-699a-4e32-ab05-648c03ed917d',orgName:'琶洲管委会展厅智能化改造项目',logobig:this.logozsybig,
      logosmall:this.logozsysmall
    },
    {
      orgId:'e77cf89e-6a5b-4d5b-b0b7-48eec45b9fbe',orgName:'琶洲管委1会展厅智能化改造项目',logobig:this.logozsybig,
      logosmall:this.logozsysmall
    },
        {
      orgId:'d3586156-78a7-4aaf-ac62-bf539e6908fb',orgName:'琶洲管委1会展厅智能化改造项目',logobig:this.ztjt,
      logosmall:this.ztjt
    },
      {
      orgId:'a14cffcf-747b-4b9b-b4f3-13a4960e8fda',orgName:'成都目',logobig:this.logoDH,
      logosmall:this.logoDH
    },

      {
      orgId:'e31247ed-c866-4804-b06c-5433356b2093',orgName:'琶洲管委1会展厅智能化改造项目',logobig:this.ztjt,
      logosmall:this.ztjt
    },
   
    {
      orgId:'68b3ecd5-5a12-4770-861b-aa92db130776',orgName:'广州创美药业智慧空间',logobig:this.logozsybig,
      logosmall:this.logozsysmall
    },
     {
      orgId:'efb65f0a-ad42-4d04-ba17-e5ff065a6ee5',orgName:'联通软件研究院广州分院',logobig:this.ltmax,
      logosmall:this.ltmin
    },
    
     {
      orgId:'00cf57a8-7ae0-4e7d-9005-8176b5d0172a',orgName:'明月山',logobig:this.zjwj,
      logosmall:this.zjwj
    }
   
   
    
  ]
  public getImg(orgId){
    console.log('orgId',this.orgId);
//标注
    if(this.state==='liantong'){
      return {
        small:this.logo4,
        big:this.logo1
      }
    }else{
      // return {
      //   small:this.logoadminsmall,
      //   big:this.logoadminbig
      // }
     
    }
    for(let i=0;i<this.orglist.length;i++){
      if(this.orglist[i].orgId==orgId){
        return {
          small:this.orglist[i].logosmall,
          big:this.orglist[i].logobig
        }
      }
    }
    return {
      small:this.logoadminsmall,
      big:this.logoadminbig
    }
  }


  get sidebar() {
    return AppModule.sidebar
  }


  get routes() {
    return (this.$router as any).options.routes
  }

  get isCollapse() {
    return !this.sidebar.opened
  }
}
